<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
if (
  window.location.protocol != "https:" &&
  !(window.location.host.indexOf("localhost") > -1)
) {
  window.location.href =
    "https:" + window.location.href.substring(window.location.protocol.length);
}

export default {
  name: "app"
};
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";
@import "./assets/scss/index";

// ETC.
html,
body {
  height: 100%;
  overflow: hidden;
  background-color: $white;
}
:focus {
  outline: 0;
}
.dashboard {
  height: 100%;
  overflow: hidden;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #4a4a4a;
  font-family: "Sukhumvit Tadmai";
  font-size: 17px;
  line-height: inherit;
  height: 100%;
}
.btn {
  border-radius: 22.5px;
  font-size: 16px;
  font-weight: bold;
}
a {
  color: $dark;
}
p {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: $black;
  word-wrap: break-word;
}
.ql-size-large {
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: -0.1px;
  text-align: left;
  color: $black;
}
.dialog-bg {
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 90;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.66);
}
.h1 {
  font-size: 32px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.84;
  letter-spacing: -0.2px;
  text-align: left;
  color: $black;
  margin-bottom: 0px;
}
.h2 {
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: $black;
  margin-top: 0;
  margin-bottom: 0px;
}
.h3 {
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.41;
  letter-spacing: normal;
  text-align: left;
  color: $black;
  margin-top: 0;
  margin-bottom: 0px;
}
.h4 {
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  color: $black;
  margin-top: 0;
  margin-bottom: 0px;
}
.h5 {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -0.1px;
  text-align: left;
  color: $black;
  margin-top: 0;
  margin-bottom: 0px;
}
.pointer {
  cursor: pointer;
}
.badge {
  border-radius: 11.7px;
  background-color: $red;
  font-size: 10.9px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: -0.1px;
  text-align: center;
  color: #ffffff;
}
/* Quill js */
.ql-toolbar.ql-snow {
  background-color: #f9f9f9;
}
blockquote {
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  text-align: center;
  padding: 20px 0px;
  margin: 20px 35px;

  font-size: 17px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.59;
  letter-spacing: normal;
  text-align: center;
  color: $black;
}
// select input
.select-input {
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  margin-right: 12px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.select-input.disabled {
  cursor: not-allowed;
  color: #C0C4CC;
}

/* Hide the browser's default checkbox */
.select-input input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  width: 24px;
  background-color: $white;
  border-radius: 4px;
  border: 1px solid #d8d6d9;
}
.checkmark.radio {
  height: 24px;
  width: 24px;
  border-radius: 50%;
}
.checkmark.radio.disabled {
  background-color: #f1f1f1;
}
.checkmark.error {
  border-color: $red;
}

/* On mouse-over, add a grey background color */
.select-input:hover input ~ .checkmark {
  background-color: #f1f1f1;
}

/* When the checkbox is checked, add a blue background */
.select-input input:checked ~ .checkmark {
  background-color: $orange;
  border-color: $orange;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.select-input input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.select-input .checkmark.radio:after {
  top: 7px;
  left: 7px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: $white;
}
.select-input .checkmark.checkbox:after {
  left: 8px;
  top: 3px;
  width: 6px;
  height: 12px;
  border: solid $white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
// google map config
.pac-container {
  z-index: 9999 !important;
}
// sprinner loader
.loader {
  border: 5px solid #444; /* Light grey */
  border-top: 5px solid #f9f9f9; /* Blue */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;

  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 80px;
  z-index: 9999 !important;
}
// override bootstrap button
button {
  border-radius: 12px;
  padding: 6px 20px;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -0.1px;
}
.btn-primary {
  color: $white;
  background-color: $orange;
  border-color: $orange;
}
.btn-primary:hover,
.btn-primary:focus {
  background-color: lighten($orange, 10%);
  border-color: lighten($orange, 10%);
  box-shadow: 0 0 0 0.2rem rgba(226, 112, 36, 0.5);
  outline: none;
}
.btn-primary:not(:disabled):not(.disabled):active {
  background-color: darken($orange, 10%);
  border-color: darken($orange, 10%);
  box-shadow: 0 0 0 0.2rem rgba(226, 112, 36, 0.5);
}
.vdatetime-input {
  border: none;
  font-weight: bold;
  background-color: transparent;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue